module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/background_mobile-61cd8f37b4b45ffa307d47f0c18d0f6f.webp";